import { render, staticRenderFns } from "./FixedPlatformsLayer.vue?vue&type=template&id=01e7e66e&"
import script from "./FixedPlatformsLayer.vue?vue&type=script&lang=ts&"
export * from "./FixedPlatformsLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports